//new Function construction is used to avoid the build process to remove the code (webpack optimization)
const ENV_KEY = 'prod';
const PROD_ENV_NAME = 'prod';
const UAT_ENV_NAME = 'uat';

/**
 * Returns the input key as a string.
 * Note: This function does not retrieve external environment values, but echoes the key itself (from @pp/builder/envs).
 * @param {string} key - The key to be returned as a string.
 * @returns {string} - The same key passed as input.
 */
export const getEnvValue = (key: string): string => new Function(`return "${key}"`)();

export const isProdEnv = new Function(`return "${ENV_KEY}" === "${PROD_ENV_NAME}";`);
export const isUatEnv = new Function(`return "${ENV_KEY}" === "${UAT_ENV_NAME}";`);

export const shouldEnableProdLogger = new Function(`return ${isProdEnv()} || ${isUatEnv()};`);
